import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Componente para proteger contenido basado en roles de usuario
 * @param {string|string[]} roles - Rol o array de roles permitidos
 * @param {React.ReactNode} children - Contenido a mostrar si el usuario tiene el rol
 * @param {React.ReactNode} fallback - Contenido alternativo si no tiene permisos
 */
const RequireRole = ({ roles, children, fallback = null }) => {
  const { user, userRole } = useAuth();

  // Si no hay usuario autenticado, no mostrar nada
  if (!user || !userRole) {
    return fallback;
  }

  // Convertir roles a array si es string
  const allowedRoles = Array.isArray(roles) ? roles : [roles];

  // Verificar si el usuario tiene alguno de los roles permitidos
  const hasPermission = allowedRoles.includes(userRole);

  return hasPermission ? children : fallback;
};

export default RequireRole;
